import { global } from "../constants";

export const data = {
    banner: {
        background: global.banner + "1.jpg",
        title: "Freight Forwarding",
        crumb: "Freight Forwarding"
    }
}